import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  card: {
    marginTop: 180,
    textAlign: 'center',
  },
  title: {
    paddingBottom: 20,
    fontWeight: 800,
    fontSize: theme.fonts.sizes.font20PX,
    borderBottom: `1px solid ${theme.colors.light.ghostWhite}`,
  },
  textMessage: {
    marginTop: -150,
    padding: '0 24px',
    fontWeight: 500,
    fontSize: 32,
    textAlign: 'center',
    color: theme.colors.light.lightCyan,
  },
  subTextMessage: {
    marginTop: -0,
    padding: '0 24px',
    fontWeight: 500,
    fontSize: 20,
    textAlign: 'center',
    color: theme.colors.light.lightCyan,
  },
  buttonGroup: {
    width: '100%',
    marginTop: 20,
  },
  buttonSeparator: {
    margin: '0 0 16px 0',
    fontSize: theme.fonts.sizes.font12PX,
    textTransform: 'uppercase',
    fontWeight: 700,
    textAlign: 'center',
    color: theme.colors.light.lightSteelBlue,
    position: 'relative',
    '&:before, &:after': {
      content: '""',
      display: 'block',
      width: '45%',
      height: 1,
      backgroundColor: theme.colors.light.lightSteelBlue,
      position: 'absolute',
      top: '50%',
      zIndex: 1,
      transform: 'translateY(-50%)',
    },

    '&:before': {
      left: 0,
    },

    '&:after': {
      right: 0,
    },
  },
}));
export const useStylesButton = makeStyles(theme => ({
  root: {
    height: 46,
    width: '100%',
    color: theme.colors.light.freshPowder,
    backgroundColor: theme.colors.dark.steelBlue,
    '&:hover': {
      backgroundColor: theme.colors.dark.steelBlue,
      color: theme.colors.light.freshPowder,
    },
  },
}));
